import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { splitJobHistories } from '@/utils/format-edit/englishResumePreview'
import EnglishResumePreviewDoc from '@/components/format-edit/english-resume/EnglishResumePreviewDoc.vue'
import EnglishResumePreviewDocPage2 from '@/components/format-edit/english-resume/EnglishResumePreviewDocPage2.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EnglishResumePreview',
  props: {
    formatData: null,
    basicData: null,
    previewScale: { default: 1 },
    currentCardId: { default: '' },
    idPrefix: { default: '' },
    isSample: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { formatData: Record<string, any>, basicData: Record<string, any>, previewScale: number, currentCardId: string | string[], idPrefix: string, isSample: boolean };



const { formLib, deviceLib } = useHostServices()

const cardChanged = ref(false)
let cardChangedTimer: ReturnType<typeof setTimeout> | null = null

const scaleStyle = computed(() => ({
  transform: `scale(${props.previewScale})`,
  'transform-origin': 'top left'
}))

const highlightMessage = computed(() =>
  deviceLib.isMobileDevice ? 'タップで編集' : 'クリックで編集'
)

const jobPages = computed(() =>
  splitJobHistories(props.formatData?.jobHistories)
)
const isTwoPage = computed(() => jobPages.value.isTwoPage)
const jobsPage1 = computed(() => jobPages.value.jobsPage1)
const jobsPage2 = computed(() => jobPages.value.jobsPage2)

const fullName = computed(() => {
  const first = props.basicData?.firstName || ''
  const last = props.basicData?.lastName || ''
  return `${first} ${last}`.trim()
})

const fullAddress = computed(() => props.formatData?.address || '')

const fullPhone = computed(() => {
  const t1 = props.basicData?.tel1 || ''
  const t2 = props.basicData?.tel2 || ''
  const t3 = props.basicData?.tel3 || ''
  if (!t1 && !t2 && !t3) return ''
  return [t1, t2, t3].filter(Boolean).join('-')
})

const formatedCreateDate = computed(() => {
  if (!props.formatData?.createDate) return ''
  return formLib.dateFormat(props.formatData.createDate, 'm/yyyy')
})

function goCardTo(id: string) {
  if (props.isSample) return
  emitter.emit('go-card-to', id)
}

function setJumpId(_nextJumpId: string) {
  cardChanged.value = true
  if (cardChangedTimer) clearTimeout(cardChangedTimer)
  cardChangedTimer = setTimeout(() => {
    cardChanged.value = false
  }, 5000)
}

onMounted(() => {
  emitter.on('show-preview-from-card', setJumpId)
})

onBeforeUnmount(() => {
  emitter.off('show-preview-from-card', setJumpId)
  if (cardChangedTimer) clearTimeout(cardChangedTimer)
})

return { __sfc: true,props, formLib, deviceLib, cardChanged, cardChangedTimer, scaleStyle, highlightMessage, jobPages, isTwoPage, jobsPage1, jobsPage2, fullName, fullAddress, fullPhone, formatedCreateDate, goCardTo, setJumpId, EnglishResumePreviewDoc, EnglishResumePreviewDocPage2 }
}

})